import script from "./ProfileSet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileSet.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileSet.vue?vue&type=style&index=0&id=3115102e&lang=scss"

const __exports__ = script;

export default __exports__